// @flow
import type { ApiExecutorType } from 'types/ApiExecutorType';

import { convertResultCalendarFromMiddleware } from 'services/Result';
import { type ResultCalendarContainerType } from 'types/Result';

function ResultCalendarApi(executor: ApiExecutorType) {
  return { fetchResultCalendar };

  // Le middleware ne prend qu'une compétition par appel : un appel par compétition, puis fusion.
  // Une compétition en erreur (404...) ne bloque pas les autres.
  function fetchResultCalendar(competitionIds: number[], structureId: number): Promise<ResultCalendarContainerType> {
    return Promise.all(
      competitionIds.map(competitionId =>
        executor
          .get(`/club-websites/result-calendar?competitionId=${competitionId}&structureId=${structureId}`)
          .then(response => (response && response.rencontres) || [])
          .catch(() => [])
      )
    ).then(responses => convertResultCalendarFromMiddleware([].concat(...responses)));
  }
}

export default ResultCalendarApi;
